import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import Header from '../components/Header';
import Marketing from '../components/Marketing';
import Hero from '../components/Hero';
import Social from '../components/Social';
import useInterval from "../hooks/useInterval";
import { noCacheReq } from '../utilities';
import { calc4k } from "../utilities";

const settings_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/settings/exhibitions';
const alert_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/alert';

export default function () {

    const [settings,setSettings] = useState(false);
    const [slides, setSlides] = useState( [] );
    const [alert,setAlert] = useState({});

    useEffect( () => {
        Promise.all( [noCacheReq( settings_url )] ).then( data => {
            const settings = data[ 0 ];
            const num_img = settings.num_img;
            let slides_arr = [];
            for( let i = 0; i < num_img; i++ ) {
                slides_arr.push({
                    image: settings[`full_image-${i}`],
                });
            }

            setSettings( settings );
            setSlides( slides_arr );
        } );
    }, [] );

    useInterval(() => {
        noCacheReq(alert_url).then( data => {
            setAlert( data );
        } );
    }, 10000 );

    return settings && slides.length ? (
        <Container>
            <Header title={settings.section_title}
                    alertSpeed={ alert.alert_speed }
                    alertActive={alert.alert_active}
                    alertMessage={alert.alert_bar_text}
                    alertOnly={true} />
            <Hero slides={slides} duration={settings.hero_slide_duration} size="full" vignette={0}/>
        </Container>
    ) : <Loading><h1>Loading...</h1></Loading>;
}

const Container = styled.div`
   display: flex;
   flex-direction: column;
`;

const Loading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
`;